
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from "./app.component";
import { NgModule } from '@angular/core';
import { LoginComponent } from './pages/login/login.component';
import { MychatroomComponent } from './pages/mychatroom/mychatroom.component';
import { LearnComponent } from './pages/learn/learn.component';
import { RegisterComponent } from './pages/register/register.component';
import { AuthGuard } from './guard/auth.guard';
import { RegisterConfirmComponent } from './pages/register-confirm/register-confirm.component';
const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent},
    { path: 'learn', component: LearnComponent, canActivate: [AuthGuard] },
    { path: 'register', component: RegisterComponent },
    { path: 'registerConfirm', component: RegisterConfirmComponent },
    { path: 'mychatroom', component: MychatroomComponent }
];
@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class RoutingModule {

}
